import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  RequestableApprover,
  type RequestableApproverConstructor,
} from '@webapp/platform/approval-routing/entities/RequestableApprover/RequestableApprover'

export const RequestableApproverContructorFactory =
  Factory.Sync.makeFactory<RequestableApproverConstructor>({
    id: Factory.each(() => faker.random.number()),
    threshold: Factory.each(() => faker.random.number()),
    userId: Factory.each(() => faker.random.number()),
    email: Factory.each(() => faker.internet.email()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    profileImage: Factory.each(() => faker.image.imageUrl()),
  })

export const RequestableApproverFactory = EntityFactory(
  RequestableApprover,
  RequestableApproverContructorFactory
)
